import { createContext } from 'react'
import type { Lang, MsgKey } from './types'

// Découpé de LanguageProvider.tsx pour la même raison qu'AuthContext.ts
// (react-refresh/only-export-components, actif dans webapp/eslint.config.js) :
// fast-refresh exige qu'un fichier de composant n'exporte que des composants,
// donc le contexte React et son type de valeur vivent ici, dans un module sans
// JSX. Ce n'est pas un goût d'architecture, c'est une contrainte d'outil.
// Refs: phase 95.

export interface LanguageContextValue {
  lang: Lang
  /**
   * Langue SUGGÉRÉE — la préférence enregistrée, à défaut `navigator.languages`.
   *
   * Elle ne commande PAS le rendu : après D-03, `lang` vient de l'URL et de
   * rien d'autre. `suggested` n'existe que pour la condition d'affichage du
   * bandeau D-07 (« Switch to English »), qui est une invitation, jamais une
   * instruction. C'est aussi ce qui rend I18N-02 / I18N-03 de nouveau
   * observables une fois que la préférence ne change plus ce que rend une URL.
   * Refs: phase 96.
   */
  suggested: Lang
  /** Vrai tant que le catalogue de la langue active n'est pas résolu. */
  loading: boolean
  /**
   * Bascule EXPLICITE — appelée UNIQUEMENT par un clic sur le sélecteur (D-06).
   *
   * Asynchrone depuis D-05 : elle écrit le stockage puis ATTEND la RPC. Son
   * appelant navigue ensuite vers la jumelle, et une navigation document tue
   * toute requête en vol — sans cette attente, la préférence ne partirait
   * jamais vers le compte. Refs: phase 96.
   */
  setLang: (next: Lang) => Promise<void>
  t: (key: MsgKey, vars?: Record<string, string | number>) => string
}

export const LanguageContext = createContext<LanguageContextValue | undefined>(undefined)
